module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-type12a312582fa730c5a7e297ffcc0ee5f5.svg";